import { selectCurrentUser, followUser } from 'features/auth/slice';
import { useDispatch, useSelector } from 'react-redux';

import { Heading, recordsContain } from '@frontendmentorio/design-system-v2';

import Avatar from 'features/shared/Avatar';
import AuthButton from 'features/shared/AuthButton';

export default function UserBanner({ user }) {
  const dispatch = useDispatch();

  const currentUser = useSelector(selectCurrentUser);
  const isFollowedByUser = recordsContain(currentUser?.following, user);

  const handleFollowUser = () => dispatch(followUser({ id: user.id }));

  return (
    <div className="bg-white p-5">
      <div className="container-xl flex flex-col flex-wrap gap-4 items-center mobile:flex-row mobile:justify-between">
        <div className="flex flex-col gap-4 items-center mobile:flex-row">
          <Avatar size="lg" user={user} withModal />

          <div className="flex flex-col gap-1 text-center mobile:text-start">
            <Heading level="5">{user.displayName}</Heading>

            <span className="neutral-500">@{user.username}</span>
          </div>
        </div>

        <AuthButton
          isGhost={isFollowedByUser}
          level="secondary"
          onClick={handleFollowUser}
        >
          {isFollowedByUser ? 'Unfollow' : 'Follow'}
        </AuthButton>
      </div>
    </div>
  );
}
